import React, { useEffect } from 'react';
import Lottie from 'lottie-web';
import anniversaryAnimation from '../../assets/lottie/RTSAnniversary.json';

type AnniversaryProps = {
  showAnniversaryStateChanger: React.Dispatch<React.SetStateAction<boolean>>;
};

const RTSProAnniversary = ({ showAnniversaryStateChanger }: AnniversaryProps) => {
  useEffect(() => {
    const lastRenderedTime = localStorage.getItem('ANNIVERSARY_LAST_RENDERED_TIME');
    const currentTime = new Date().getTime();
    const twentyFourHours = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
    if (!lastRenderedTime || currentTime - parseInt(lastRenderedTime, 10) >= twentyFourHours) {
      // Anniversary was never rendered or it has been more than 24 hours
      localStorage.setItem('ANNIVERSARY_LAST_RENDERED_TIME', currentTime.toString());
    } else {
      // Anniversary was rendered less than 24 hours ago
      showAnniversaryStateChanger(false);
    }

    Lottie.loadAnimation({
      name: 'RTSProAnniversary',
      animationData: anniversaryAnimation,
      container: document.querySelector('#RTSProAnniversary'),
      loop: false,
    }).addEventListener('complete', () => {
      showAnniversaryStateChanger(false);
    });

    return () => Lottie.destroy('RTSProAnniversary');
  }, []);

  return (
    <div
      id="RTSProAnniversary"
      style={{ position: 'absolute', top: '40%', left: '50%', transform: 'translate(-50%, -50%)' }}
    />
  );
};

export default RTSProAnniversary;
